export enum StatsQuery {
  Weighting = 'w',
  ChartType = 'ty',
}

export enum StatsWeight {
  Count = 'c',
  MarketCap = 'm',
}

export enum StatsChartType {
  Pie = 'p',
  Bar = 'b',
  Table = 't',
}

export interface StatsDataRow {
  label: string
  value: number
}

export interface StatsGroup {
  [StatsWeight.Count]: StatsDataRow[]
  [StatsWeight.MarketCap]: StatsDataRow[]
}

export interface StatsData {
  sectors: StatsGroup
  marketCap: StatsGroup
  countries: StatsGroup
  industries: StatsGroup
}

export type StatsRounding = 'regular' | 'none'
